import { cacheDom } from '../utils/QuerySelectors.js'
import { setupPaginations } from '../components/Pagination.js'
import store from '../apps/store/store'
import { setColorMode } from '../apps/store/productTileSlice'
import { getXgenProducts } from '../utils/Product.js'
import { showAlertMessage } from '../utils/helpers.js'

const state = {
  filterOpened: false,
  sortOpened: false,
  colorOpened: false,
}
const dom = {}
const qs = {
  facetsContainer: 'data-facets-container',
  productsGrid: 'data-products-grid',
  filterSortContainer: 'data-plp-filter-sort',
  filterContainer: 'data-plp-filter',
  sortContainer: 'data-plp-sort',
  colorContainer: 'data-plp-color',
  filterBtn: 'data-plp-filter-btn',
  sortBtn: 'data-plp-sort-btn',
  colorBtn: 'data-plp-color-btn',
  plpPaginator: 'data-plp-paginator',
  plpTypesFilter: 'data-plp-types-filter',
  statusMessage: 'data-filter-status',
  // count: 'data-plp-count',
}
const qsAll = {
  facets: 'data-facet',
  facetRemoves: 'data-facet-remove',
  clearFacets: 'data-clear',
  filterChild: 'data-filter-child',
  sortButtons: 'data-sort-option',
  colorOptions: 'data-color-option',
  // inlineTypeFilters: 'data-inline-type-filter',
  mobileFilterSortCloses: 'data-mobile-filtersort-close',
}
const activeClasses = ['sort-selected', 'bg-fore', 'text-back']
const regularClasses = ['text-fore', 'border-fore', 'border', 'hover:bg-fore', 'text-fore', 'hover:text-back']
const plpFilterSortOpenClass = 'plp-filter-sort-open'
const plpCookieWidgetStyleId = 'plp-cookie-widget-position'
let plpCookieWidgetObserver = null
let plpCookieWidgetObserverTimeout = null
let plpCookieWidgetResizeInitialized = false

const applyPlpCookieWidgetStyles = () => {
  const cookieWidget = document.querySelector('pandectes-cmp')
  const cookieWidgetRoot = cookieWidget?.shadowRoot
  if (!cookieWidgetRoot) return false

  if (cookieWidgetRoot.getElementById(plpCookieWidgetStyleId)) return true

  const style = document.createElement('style')
  style.id = plpCookieWidgetStyleId
  style.textContent = `
    @media (max-width: 1023px) {
      button.widget {
        bottom: 3.75rem !important;
        left: auto !important;
        right: 0.75rem !important;
      }
    }
  `
  cookieWidgetRoot.appendChild(style)
  return true
}

const disconnectPlpCookieWidgetObserver = () => {
  if (plpCookieWidgetObserver) {
    plpCookieWidgetObserver.disconnect()
    plpCookieWidgetObserver = null
  }

  if (plpCookieWidgetObserverTimeout) {
    window.clearTimeout(plpCookieWidgetObserverTimeout)
    plpCookieWidgetObserverTimeout = null
  }
}

const observePlpCookieWidgetStyles = () => {
  if (plpCookieWidgetObserver) return

  plpCookieWidgetObserver = new MutationObserver(() => {
    if (applyPlpCookieWidgetStyles()) disconnectPlpCookieWidgetObserver()
  })

  plpCookieWidgetObserver.observe(document.documentElement, { childList: true, subtree: true })
  plpCookieWidgetObserverTimeout = window.setTimeout(disconnectPlpCookieWidgetObserver, 10000)
}

const ensurePlpCookieWidgetStyles = () => {
  if (applyPlpCookieWidgetStyles()) return

  observePlpCookieWidgetStyles()
}

const initPlpCookieWidgetStyles = () => {
  ensurePlpCookieWidgetStyles()

  if (plpCookieWidgetResizeInitialized) return

  plpCookieWidgetResizeInitialized = true
  window.addEventListener('resize', () => {
    if (window.innerWidth < 1024) ensurePlpCookieWidgetStyles()
  })
}

const openFilterSort = () => {
  if (window.innerWidth >= 1024) {
    // Adjust classes for enabling desktop panel
    dom.filterSortContainer.classList.add('!w-[20.5rem]', '!overflow-auto')
    dom.plpPaginator.classList.add('w-[calc(100%-21.5rem)]')
    dom.plpPaginator.classList.remove('w-full')
    dom.productsGrid.classList.add('gap-x-4')

    // Adjust classes for disabling mobile panel
    dom.filterSortContainer.classList.remove('block', '!w-full')
    dom.filterSortContainer.classList.add('hidden')
    document.body.classList.remove('overflow-hidden', plpFilterSortOpenClass)
  } else {
    // Adjust classes for disabling desktop panel
    dom.filterSortContainer.classList.remove('!w-[20.5rem]', '!overflow-auto')
    dom.plpPaginator.classList.remove('w-[calc(100%-21.5rem)]')
    dom.plpPaginator.classList.add('w-full')
    dom.productsGrid.classList.remove('gap-x-4')

    // Adjust classes for enabling mobile panel
    dom.filterSortContainer.classList.add('block', '!w-full')
    dom.filterSortContainer.classList.remove('hidden')
    document.body.classList.add('overflow-hidden', plpFilterSortOpenClass)
  }
}

const closeFilterSort = () => {
  // Adjust classes for disabling desktop panel
  dom.filterSortContainer.classList.remove('!w-[20.5rem]', '!overflow-auto')
  dom.plpPaginator.classList.remove('w-[calc(100%-21.5rem)]')
  dom.plpPaginator.classList.add('w-full')
  dom.productsGrid.classList.remove('gap-x-4')

  // Adjust classes for disabling mobile panel
  dom.filterSortContainer.classList.remove('block', '!w-full')
  dom.filterSortContainer.classList.add('hidden')
  document.body.classList.remove('overflow-hidden', plpFilterSortOpenClass)
}

const updateColorClasses = () => {
  if (window.currentPlpColor) {
    dom.colorOptions.forEach((colorOption) => {
      if (colorOption.getAttribute(qsAll.colorOptions) == window.currentPlpColor) {
        colorOption.classList.add(...activeClasses)
        colorOption.classList.remove(...regularClasses)
        colorOption.setAttribute('aria-pressed', 'true')
      } else {
        colorOption.classList.remove(...activeClasses)
        colorOption.classList.add(...regularClasses)
        colorOption.setAttribute('aria-pressed', 'false')
      }
    })
  }
}

const initFilterFacets = (openedFilterIndexes = []) => {
  dom.facets.forEach((facet) => {
    facet.addEventListener('click', () => {
      renderFilterResults()
    })
    facet.addEventListener('keyup', (event) => {
      if (event.key === 'Enter') {
        facet.checked = !facet.checked
        facet.dispatchEvent(new Event('click'))
      }
    })
  })

  dom.clearFacets.forEach((clearBtn) => {
    clearBtn.addEventListener('click', (e) => {
      const removeUrl = e.target.dataset.url
      fetchResults(removeUrl, 'reset')
    })
    clearBtn.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        dom.filterBtn.focus()
      }
    })
  })
  dom.facetRemoves.forEach((facetRemove) => {
    facetRemove.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      const removeUrl = `${facetRemove.href}&section_id=${dom.facetsContainer.dataset.sectionId}`
      fetchResults(removeUrl, 'remove_option')
    })
  })
  if (openedFilterIndexes.length > 0) {
    dom.facetsContainer.querySelectorAll(`[${qsAll.filterChild}]`).forEach((child, index) => {
      if (openedFilterIndexes.includes(index)) child.querySelector('details').setAttribute('open', '')
    })
  }

  if (state.filterOpened) {
    openFilterSort()
    dom.filterContainer.classList.add('!block')
  }
  if (state.sortOpened) {
    openFilterSort()
    dom.sortContainer.classList.add('!block')
  }
  if (state.colorOpened) {
    openFilterSort()
    dom.colorContainer.classList.add('!block')
  }

  updateColorClasses()

  dom.sortButtons.forEach((sortBtn) => {
    const sortActiveClasses = activeClasses.concat('sort-selected')

    sortBtn.addEventListener('click', () => {
      dom.sortButtons.forEach((button) => {
        if (button == sortBtn) {
          button.classList.add(...sortActiveClasses)
          button.classList.remove(...regularClasses)
          button.setAttribute('aria-pressed', 'true')
        } else {
          button.classList.remove(...sortActiveClasses)
          button.classList.add(...regularClasses)
          button.setAttribute('aria-pressed', 'false')
        }
        button.disabled = true
      })
      renderFilterResults()
    })
  })
  document.querySelector(`[data-sort-index="4"]`)?.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
      dom.sortBtn.focus()
    }
  })
  document.querySelector(`[data-color-index="2"]`)?.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
      dom.colorBtn.focus()
    }
  })
  dom.colorOptions.forEach((colorOption) => {
    colorOption.addEventListener('click', (e) => {
      const option = colorOption.getAttribute(qsAll.colorOptions)
      store.dispatch(setColorMode(option))
      window.currentPlpColor = option
      updateColorClasses()
    })
  })

  dom.filterSortContainer.querySelectorAll('summary').forEach((summary) => {
    summary.addEventListener('click', (e) => {
      e.stopPropagation()
    })
  })

  // dom.inlineTypeFilters.forEach((typeFilter) => {
  //   typeFilter.addEventListener('click', (e) => {
  //     e.target.classList.toggle('button--active')
  //     const filterOption = document.querySelector(`[name="${e.target.dataset.filterName}"][value="${e.target.dataset.value}"]`)
  //     if(filterOption) {
  //       filterOption.checked = e.target.classList.contains('button--active')
  //       renderFilterResults()
  //     }
  //   })
  // })
  dom.mobileFilterSortCloses.forEach((mobileFilterSortClose) => {
    mobileFilterSortClose.addEventListener('click', (e) => {
      closeFilterSort()
      state.filterOpened = false
      state.sortOpened = false
      state.colorOpened = false
      dom.sortBtn.classList.remove('!underline')
      dom.filterBtn.classList.remove('!underline')
      if (dom.colorBtn) {
        dom.colorBtn.classList.remove('!underline')
      }
    })
  })
}

const fetchResults = (url, status = 'apply') => {
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      if (dom.plpPaginator) dom.plpPaginator.innerHTML = html.querySelector(`[${qs.plpPaginator}]`).innerHTML

      const openedFilterIndexes = []
      dom.facetsContainer.querySelectorAll('details[open]').forEach((detail) => {
        openedFilterIndexes.push(parseInt(detail.dataset.index))
      })
      if (dom.filterSortContainer)
        dom.filterSortContainer.innerHTML = html.querySelector(`[${qs.filterSortContainer}]`).innerHTML
      if (dom.plpTypesFilter) dom.plpTypesFilter.innerHTML = html.querySelector(`[${qs.plpTypesFilter}]`).innerHTML
      // if(dom.count) dom.count.innerHTML = html.querySelector(`[${qs.count}]`).innerHTML

      cacheDom(dom, qs, qsAll)
      window.setupProductTiles(document.querySelectorAll('[product-tile="false"]'))
      initFilterFacets(openedFilterIndexes)
      setupPaginations()
      if (location.pathname != dom.productsGrid.dataset.productsGrid)
        history.pushState({}, '', dom.productsGrid.dataset.productsGrid)
      initPlpXgen()

      if (status == 'reset') {
        showAlertMessage(window.statusMessageStrings.filterReset)
      } else if (status == 'remove_option') {
        showAlertMessage(window.statusMessageStrings.filterOptionRemoved)
      } else {
        showAlertMessage(window.statusMessageStrings.filterApplied)
      }
    })
}

const renderFilterResults = () => {
  const selectedFacets = dom.facets
    .filter((facet) => facet.checked)
    .map((facet) => encodeURI(`${facet.name}=${facet.value}`))
    .join('&')
  const filterUrl = `${dom.productsGrid.dataset.productsGrid}?section_id=${dom.facetsContainer.dataset.sectionId}&${selectedFacets}&sort_by=${document.querySelector('.sort-selected[' + qsAll.sortButtons + ']')?.getAttribute(qsAll.sortButtons) || ''}`
  fetchResults(filterUrl)
}

export const initPlpXgen = () => {
  const xgens = document.querySelectorAll('[data-plp-xgen]')
  xgens.forEach((xgen) => {
    const xgenGrid = xgen.querySelector('[data-plp-xgen-grid]')
    if (xgenGrid.innerHTML.trim() == '') {
      const xgenId = xgen.getAttribute('data-plp-xgen')
      const rows = parseInt(xgen.getAttribute('data-rows'))
      const excludeSale = xgen.getAttribute('data-exclude-sale')
      if (typeof getXgenPredictions != 'undefined') {
        getXgenPredictions(xgenId).then((results) => {
          const skus = results.map((result) => result.variants[0].sku).filter(Boolean)
          getXgenProducts((results) => {
            const filteredResults =
              excludeSale == 'true'
                ? results.filter((result) => !result.tags.includes('Sale') && !result.tags.includes('Final Sale'))
                : results
            filteredResults.slice(0, rows * 3).forEach((result, index) => {
              xgenGrid.innerHTML += `
                <style>
                  @media (max-width: 1023px) {
                    .plp-xgen-mobile[data-plp-xgen="${xgenId}"] ~ [data-product-id="${result.id.replace('gid://shopify/Product/', '')}"] { display: none }
                  }
                  @media (min-width: 1024px) {
                    .plp-xgen-desktop[data-plp-xgen="${xgenId}"] ~ [data-product-id="${result.id.replace('gid://shopify/Product/', '')}"] { display: none }
                  }
                </style>
                <div class="h-full ${(rows == 1 && index > 1) || (rows == 2 && index > 3) ? 'hidden lg:block' : ''}" product-tile props='${JSON.stringify(result).replaceAll("'", '’')}'></div>
              `
            })
            window.setupProductTiles(xgen.querySelectorAll('[product-tile]:empty'))
          }, skus)
        })
      }
    }
  })
}

export const setupCollection = () => {
  if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')) {
    cacheDom(dom, qs, qsAll)
    initPlpCookieWidgetStyles()

    if (dom.filterBtn) {
      dom.filterBtn.addEventListener('click', (e) => {
        e.stopPropagation()
        e.target.classList.toggle('!underline')
        dom.sortBtn.classList.remove('!underline')
        dom.sortContainer.classList.remove('!block')

        if (dom.colorBtn) {
          dom.colorBtn.classList.remove('!underline')
          dom.colorContainer.classList.remove('!block')
        }

        state.sortOpened = false
        state.colorOpened = false
        if (e.target.classList.contains('!underline')) {
          openFilterSort()
          dom.filterContainer.classList.add('!block')
          state.filterOpened = true
          dom.filterContainer.querySelector('[data-facet-remove], summary').focus()
        } else {
          closeFilterSort()
          state.filterOpened = false
        }
      })
    }

    if (dom.sortBtn) {
      dom.sortBtn.addEventListener('click', (e) => {
        e.stopPropagation()
        e.target.classList.toggle('!underline')
        dom.filterBtn.classList.remove('!underline')
        dom.filterContainer.classList.remove('!block')

        if (dom.colorBtn) {
          dom.colorBtn.classList.remove('!underline')
          dom.colorContainer.classList.remove('!block')
        }

        state.filterOpened = false
        state.colorOpened = false
        if (e.target.classList.contains('!underline')) {
          openFilterSort()
          dom.sortContainer.classList.add('!block')
          state.sortOpened = true
          dom.sortContainer.querySelector('button[data-sort-option]').focus()
        } else {
          closeFilterSort()
          state.sortOpened = false
        }
      })
    }
    if (dom.colorBtn) {
      dom.colorBtn.addEventListener('click', (e) => {
        e.stopPropagation()
        e.target.classList.toggle('!underline')
        dom.filterBtn.classList.remove('!underline')
        dom.filterContainer.classList.remove('!block')

        dom.sortBtn.classList.remove('!underline')
        dom.sortContainer.classList.remove('!block')

        state.filterOpened = false
        state.sortOpened = false
        if (e.target.classList.contains('!underline')) {
          openFilterSort()
          dom.colorContainer.classList.add('!block')
          state.colorOpened = true
          dom.colorContainer.querySelector('button[data-color-option]').focus()
        } else {
          closeFilterSort()
          state.colorOpened = false
        }
      })
    }

    if (dom.filterSortContainer) {
      dom.filterSortContainer.addEventListener('click', (e) => {
        if (window.innerWidth >= 1024) e.stopPropagation()
      })
      dom.sortContainer.addEventListener('click', (e) => {
        e.stopPropagation()
      })
      dom.filterContainer.addEventListener('click', (e) => {
        e.stopPropagation()
      })
      dom.colorContainer.addEventListener('click', (e) => {
        e.stopPropagation()
      })

      document.body.addEventListener('click', () => {
        dom.sortBtn.classList.remove('!underline')
        dom.sortContainer.classList.remove('!block')
        dom.filterBtn.classList.remove('!underline')
        dom.filterContainer.classList.remove('!block')
        if (dom.colorBtn) {
          dom.colorBtn.classList.remove('!underline')
          dom.colorContainer.classList.remove('!block')
        }

        closeFilterSort()
      })

      initFilterFacets()
    }

    initPlpXgen()
  }
}
